import axios from "axios";
import { getEnvVariable, REACT_APP_API_URL } from "utils/environment";
import { retrieveTokenFromLocalStorage } from "services/utils/serviceutils";
import { InternalLayer } from "components/adhoc/gistreeformbottom";

/* SOC Hierarchy controller */

export const getAllGisLayersTable = () => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}gisLayer/table`;
    const config: any = {
        method: "get",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const updateGisLayers = (assignments: any[]) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}gisLayer/table`;
    const config: any = {
        method: "put",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
        data: assignments,
    };
    return axios(config);
};

/* SOC Hierarchy controller */

/* internalLayerController*/
export const internalLayerController = () => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}internalLayer/`;
    const config: any = {
        method: "get",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};
/* internalLayerController*/

/* internalLayerController*/
export const saveNewInternalLayer = (hierarchyItem: InternalLayer) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}gisLayer/internal/`;
    const config: any = {
        method: "post",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
        data: hierarchyItem,
    };
    return axios(config);
};
/* internalLayerController*/

/* GIS Layer Controller */

export const getAllGisLayers = () => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}gisLayer/`;
    const config: any = {
        method: "get",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const deleteGisLayer = (layerId: number) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}gisLayer/${layerId}`;
    const config: any = {
        method: "delete",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const createGisLayer = (details: any) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}gisLayer/`;
    const config: any = {
        method: "post",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
        data: details,
    };
    return axios(config);
};

export const updateGisLayer = (details: any) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}gisLayer/`;
    const config: any = {
        method: "put",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
        data: details,
    };
    return axios(config);
};
